// extracted by mini-css-extract-plugin
export var pageInner = "page-module--pageInner--QB6aS";
export var page = "page-module--page--rq93C";
export var active = "page-module--active--9hULS";
export var scrollTip = "page-module--scrollTip--RKIkR";
export var share = "page-module--share--t98jT";
export var qr = "page-module--qr--wGZBl";